import { render, staticRenderFns } from "./CandidatePortalLogo.vue?vue&type=template&id=a1e60bc0&scoped=true&"
import script from "./CandidatePortalLogo.vue?vue&type=script&lang=ts&"
export * from "./CandidatePortalLogo.vue?vue&type=script&lang=ts&"
import style0 from "./CandidatePortalLogo.vue?vue&type=style&index=0&id=a1e60bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e60bc0",
  null
  
)

export default component.exports